(function () {
	'use strict';

	angular.module('app.core')
		.service('uploadUserModalService', uploadUserModalService);

	uploadUserModalService.$inject = ['URLS', '$uibModal', '$experiments', 'storeService', 'Upload', 'leanFilterService'];

	function uploadUserModalService(URLS, $uibModal, $experiments, storeService, Upload, leanFilterService) {
		var service = {
			openImportModal: openImportModal
		};

		return service;

		function openImportModal(args, $rootScope, $scope) {
			if (!args) return;

			var uploadScope = $scope.$new();
			uploadScope.uploadFile = function (file, errFiles) {
				uploadScope.closeDialog();
				uploadFile(file, errFiles, args, $scope, $rootScope);
			};

			uploadScope.header = 'Import users results';
			
			var opts = {
				scope: uploadScope,
				templateUrl: args.template,
				windowClass: 'uib-modal-z-above-pendo',
				backdropClass: 'uib-modal-backdrop-z-above-pendo'
			};

			uploadScope.downloadExcelTemplate = function () {
				var adminConfig = storeService.getState().adminConfig;
				jQuery.fileDownload(URLS.host + URLS.prefix + adminConfig.factory.id + '/Template/' + args.s3XLSXFilePath, {
					httpMethod: 'GET',
					encodeHTMLEntities: false,
					successCallback: function (url) { },
					failCallback: function (responseHtml, url) {
						$rootScope.$emit('toast', {
							'message': 'Unable to Download XLSX Template',
							'success': false
						});
					}
				});
			};

			var instance = $uibModal.open(opts);
			uploadScope.closeDialog = function () {
				instance.close();
				uploadScope.$destroy();
			};
		}

		function uploadFile(file, errFiles, uploadArgs, $scope, $rootScope) {
			var errFile = errFiles && errFiles[0];
			if (file) {
				var uploadScope = $scope.$new();
				uploadScope.progressValue = 0;
				uploadScope.showProcessingMessage = false;
				uploadScope.showResults = false;
				uploadScope.allowClose = false;
				uploadScope.progressType = 'primary';
				uploadScope.isSupplier = uploadArgs.isSupplier !== undefined && uploadArgs.isSupplier;
				file.upload = Upload.upload({
					url: '/api/2/companyId/' + globalConfig.customer.id + uploadArgs.uploadPath,
					data: { file: file },
					headers: {
						'isFileUpload': true
					}
				});
				var opts = {
					scope: uploadScope,
					templateUrl: uploadArgs.uploadResultTemplate,
					backdrop: 'static',
					windowTemplateUrl: '/application/f/reports/upload_comments_template.html'
				};
				var instance = $uibModal.open(opts);
				uploadScope.closeModal = function () {
					instance.close();
					uploadScope.$destroy();
					$scope.$broadcast('reloadTable');
				};
				file.upload.then(function (response) {
					if (response.status && response.status >= 200 && response.status < 400) {
						uploadScope.showProcessingMessage = false;
						uploadScope.showResults = true;
						uploadScope.resultsData = response.data;
						uploadScope.allowClose = true;
						uploadScope.progressType = response.data.rowsRejected === 0 ? 'success' : response.data.rowsProcessed > 0 ? 'warning' : 'danger';
					}
				}, function (response) {
					uploadScope.progressType = 'danger';
					if (response.status > 0) {
						if (response.data && response.data.errors && response.data.errors.length) {
							uploadScope.showResults = false;
							uploadScope.errorData = response.data.errors[0].message;
						} else {
							uploadScope.errorData = 'Unknown error with file.';
						}
						uploadScope.showProcessingMessage = false;
						uploadScope.showError = true;
						uploadScope.allowClose = true;
					}
				}, function (evt) {
					file.progress = Math.min(100, parseInt(100.0 * evt.loaded / evt.total));
					uploadScope.progressValue = file.progress;
					if (uploadScope.progressValue >= 100) {
						uploadScope.showProcessingMessage = true;
					}
				});
			} else if (errFile) {
				$rootScope.$emit('toast', {
					message: 'Invalid file (must be .xlsx)',
					success: false
				});
			}
		}
	}
})();